import React, { useState, useEffect } from "react";
import { Play, Menu, X } from "lucide-react";
import "./style.css";
import loadConfig from "../../../Services/Api/ApiServices";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

const SubNavBarManager = () => {
  const [jsonData, setJsonData] = useState();
  const UserInfo = useSelector((state) => state.UserInfo.UserInfo);
  const lang = useSelector((state) => state.languageReducer.Language);

  const [menuOpen, setMenuOpen] = useState(false);
  const RouteManagerList = useSelector(
    (state) => state.RouteManagerReducer.RouteManager
  );
  const navigate = useNavigate();
  let location = useLocation();
  const ApplicantInformation = useSelector(
    (state) => state.ApplicantInformation.ApplicantInformation
  );

  const dispatch = useDispatch();
  // Load JSON data
  const fetchData = async () => {
    const data = await loadConfig();
    setJsonData(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Find active tab from current URL
  console.log(
    RouteManagerList?.filter((role) => role.isPageNavBar == true),
    "RouteManagerListRouteManagerList"
  );

  const activeTab = RouteManagerList?.filter(
    (role) => role.isPageNavBar == true 
  )?.find((item) =>
    item.routeManagerNamePath.includes(
      location.pathname.split("/").filter((part) => part.trim() !== "")[2]
    )
  )?.routeManagerNamePath;
  console.log(activeTab, "SdwdfwfwfactiveTab");

  useEffect(() => {
    console.log(
      location.pathname.split("/").includes("ViewApplication"),
      "dsfsefffffffffffefe"
    );

    if (
      activeTab == undefined &&
      location.pathname.split("/").includes("ViewApplication") === false
    ) {
      const array = RouteManagerList?.filter((ele) => {
        return ele?.isPageNavBar == true;
      }).sort((a) => a.sorting);
      for (const item of array) {
        if (
          item?.roleList.some((role) =>
            JSON.parse(UserInfo?.roles)
              ?.map((r) => r?.RoleId)
              .includes(role)
          )
        ) {
          navigate(item.routeManagerNamePath);
          break; // يتوقف عند أول تنفيذ للشرط
        }
      }
    }
  }, [RouteManagerList, activeTab]);
  const handleTabClick = (tabId, href) => {
    console.log(activeTab, href, "sssssssssssdfdfdfssssdwd");

    setMenuOpen(false);
    if (href) {
      navigate(href, { state: { from: location.pathname } });
    }
  };

  const handleVideoClick = (e, videoUrl) => {
    e.stopPropagation();
    e.preventDefault();
    if (videoUrl) {
      window.open(videoUrl, "_blank");
    }
  };
  console.log(
    RouteManagerList?.filter((role) => role.isPageNavBar == true),
    "ssssssssdwdwd",
    UserInfo
  );

  return (
    <nav className="enhanced-navbar">
      <div className="enhanced-navbar-container">
        {/* Mobile burger button */}
        <button
          className="burger-button"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Overlay */}
        {menuOpen && (
          <div
            className="enhanced-navbar-overlay"
            onClick={() => setMenuOpen(false)}
          ></div>
        )}

        {/* Navigation items */}
        <ul className={`enhanced-navbar-list ${menuOpen ? "open" : ""}`}>
          {RouteManagerList?.filter((role) => role.isPageNavBar == true)?.map(
            (item, index) => {
              if (
                item?.roleList.some((role) =>
                  JSON.parse(UserInfo?.roles)
                    ?.map((role) => role?.RoleId)
                    .includes(role)
                )
              ) {
                return (
                  <li
                    key={item.routeManagerNameText}
                    className={`enhanced-navbar-item ${
                      index ===
                      RouteManagerList?.filter(
                        (role) => role.isPageNavBar == true
                      )?.length -
                        1
                        ? "last-item"
                        : ""
                    }`}
                  >
                    <a
                      href={item.routeManagerNamePath}
                      onClick={(e) => {
                        e.preventDefault();
                        handleTabClick(
                          lang=="en"?item.routeManagerNameTextEn:item.routeManagerNameText,
                          item.routeManagerNamePath
                        );
                      }}
                      className={`enhanced-navbar-link ${
                        activeTab === item.routeManagerNamePath ? "active" : ""
                      }`}
                    >
                      <div className="enhanced-content-wrapper">
                        <span className="enhanced-text">
                          {lang=="en"?item.routeManagerNameTextEn:item.routeManagerNameText}
                        </span>

                        {item.videoUrl && (
                          <button
                            onClick={(e) => handleVideoClick(e, item.videoUrl)}
                            className="enhanced-video-btn"
                            // title={`${
                            //   lang === "ar"
                            //     ? `مشاهدة فيديو ${item.nameAR}`
                            //     : `Watch Video ${item.nameEN}`
                            // }`}
                          >
                            <Play size={14} />
                          </button>
                        )}
                      </div>
                      <div className="enhanced-accent-border"></div>
                    </a>
                  </li>
                );
              }
            }
          )}
        </ul>
      </div>
    </nav>
  );
};

export default SubNavBarManager;
